'use strict';

import React from 'react'
import '../utility/tooltip'

export default React.createClass({

	getInitialState () {
		return {};
	},

	render () {
		return (
			<div className="row" style={{marginTop:'20px'}}>
				<div className="col-xs-1 col-sm-1 col-md-1">
					<div className="vx_checkbox">
						<input
							type="checkbox"
							onChange={this.props.handleShareAddress}
							name="consentShareAddress"/>
							<label> </label>
					</div>
				</div>
				<div className="tool_tip_holder">
					<div className="col-xs-11 col-sm-11 col-md-11 show_tool_tip">
						<p style={{marginTop:'3px'}}>{this.props.label}
						<span className="icon icon-small icon-tooltip-small" aria-hidden="true"></span>
						</p>
					</div>
					<div className="col-xs-12 col-sm-12 col-md-12 tool_tip">
						<span className="tool_tip_text">{this.props.toolTipText}</span>
					</div>
				</div>
			</div>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./guest/addressCheckbox.js
 **/